import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
  onReset: () => void;
}

interface State {
  error: Error | null;
}

class BulkUploadErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Bulk upload wizard render error:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 text-center space-y-3">
          <p className="text-destructive font-medium">Something went wrong</p>
          <p className="text-sm text-muted-foreground">{this.state.error.message}</p>
          {import.meta.env.DEV && (
            <pre className="text-xs text-left bg-muted p-3 rounded max-h-40 overflow-auto">
              {this.state.error.stack}
            </pre>
          )}
          <button
            className="text-sm text-primary underline"
            onClick={() => { this.setState({ error: null }); this.props.onReset(); }}
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default BulkUploadErrorBoundary;
